import { MOT_TYPE, TRANSITION_TYPE, TRANSPORTATION_CATEGORY } from '../../enums/model.enums';
import { Provider } from './provider';
import { MetaData } from '../MetaData';
import { isUndefined } from 'util';
export class Mot extends MetaData {
    /**
     * constructor of class
     * please use factory instead
     * @see {this.factory)
     * @param id
     * @param type
     * @param category
     * @param metaData
     */
    constructor(id, type, category, providers, metaData) {
        super(metaData);
        this._id = id;
        this._type = type;
        this._category = category;
        this._providers = providers;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {Mot}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.id = values.id || '';
        sanitizedValues.category = values.category || TRANSPORTATION_CATEGORY.MOT;
        if (values.type && typeof values.type === 'string') {
            sanitizedValues.type = this.getMotType(values.type, sanitizedValues.category);
        }
        else {
            sanitizedValues.type = values.type;
        }
        sanitizedValues.providers = [];
        if (values.providers) {
            for (const provider of values.providers) {
                sanitizedValues.providers.push(Provider.factory(provider));
            }
        }
        sanitizedValues.metaData = !isUndefined(values.metaData) ? values.metaData : {};
        return new Mot(sanitizedValues.id, sanitizedValues.type, sanitizedValues.category, sanitizedValues.providers, sanitizedValues.metaData);
    }
    static getMotType(s, category) {
        let returnValue;
        if (category === TRANSPORTATION_CATEGORY.TRANSITION) {
            returnValue = TRANSITION_TYPE[s.toUpperCase()];
        }
        else {
            returnValue = MOT_TYPE[s.toUpperCase()];
        }
        return returnValue;
    }
    /**
     * gets the internal _id
     * @returns {string}
     */
    get id() {
        return this._id;
    }
    /**
     * sets the internal _id
     * @param value
     */
    set id(value) {
        this._id = value;
    }
    /**
     * gets the mot type specified as enum {MOT_TYPE}
     * @returns {MOT_TYPE}
     */
    get type() {
        return this._type;
    }
    /**
     * sets the mot type specified as enum {MOT_TYPE}
     * @param type
     */
    set type(type) {
        this._type = type;
    }
    /**
     * gets the transportation type specified as enum {TRANSPORTATION_CATEGORY}
     * @returns {TRANSPORTATION_CATEGORY}
     */
    get category() {
        return this._category;
    }
    /**
     * sets the transportation type specified as enum {TRANSPORTATION_CATEGORY}
     * @param type
     */
    set category(category) {
        this._category = category;
    }
    /**
     * gets the providers
     * @returns {Provider}
     */
    get providers() {
        return this._providers;
    }
    /**
     * sets the providers
     * @param providers
     */
    set providers(providers) {
        this._providers = providers;
    }
}
//# sourceMappingURL=mot.js.map